import { useNavigate } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  path?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const navigate = useNavigate();

  return (
    <nav aria-label="面包屑导航" className="flex items-center gap-2 text-sm text-foreground-500">
      {items.map((item, index) => (
        <span key={index} className="flex items-center gap-2">
          {index > 0 && <i className="ri-arrow-right-s-line text-xs"></i>}
          {item.path ? (
            <a
              href={item.path}
              onClick={(e) => { e.preventDefault(); navigate(item.path); }}
              className="hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
            >
              {item.label}
            </a>
          ) : (
            <span className="text-foreground-700 font-medium">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}